/** jQuery JavaScript for pregnancyleave functionality **/
(function (pregnancyleave, $) {

    pregnancyleave.clickedSubmitButton = undefined;
    pregnancyleave.calculateButtonClicked = false;

    /** Initializes the Javascript for pregnancy leave */
    pregnancyleave.init = function (pregnancyLeaveRequestKey) {
        pregnancyleave.loadStartDateRange();

        pregnancyleave.bindExpectedDeliveryDateEvent();
        pregnancyleave.bindRegionEvent();
        pregnancyleave.bindInputEvent();
        pregnancyleave.initPartial();
        pregnancyleave.initAbsencesTable(pregnancyLeaveRequestKey);
    }

    /** Initializes the Javascript the pregnancy leave partial */
    pregnancyleave.initPartial = function () {
        pregnancyleave.calculateEvent();
        pregnancyleave.submitEvent();
    }

    /** Method that binds the expected delivery date on change event  */
    pregnancyleave.bindExpectedDeliveryDateEvent = function () {
        $(document).on("change", "[data-expecteddeliverydate],[data-multiplebirths]", pregnancyleave.loadStartDateRange);
    }

    /** Method that binds the region change event */
    pregnancyleave.bindRegionEvent = function () {
        $(document).on("change", "[data-region]", function (evt) {
            var region = evt.target.value;
            var pregnancyLeaveRequestKey = $("[data-pregnancyleave-request-key]").val();
            $.get(`/PregnancyLeave/Home/UpdateAbsencesGrid?pregnancyLeaveRequestKey=${pregnancyLeaveRequestKey}&region=${region}`)
                .done((jqXHR) => {
                    $("#absencestable").DataTable().ajax.reload();
                });
        });
    }

    /** Method that binds the input change event */
    pregnancyleave.bindInputEvent = function () {
        $(document).on("change", "[data-input]", function () {
            $("[data-submit-button]").prop('disabled', true);
        });
    }

    /** Method that binds the calculate button event */
    pregnancyleave.calculateEvent = function () {
        $(document).on("click", "[data-calculate-button]", function (evt) {
            pregnancyleave.clickedSubmitButton = evt.target;
            pregnancyleave.calculateButtonClicked = true;
        });
    }

    /** Method that binds the submit event */
    pregnancyleave.submitEvent = function () {
        $(document).on("click", "[data-submit-button]", function (evt) {
            pregnancyleave.clickedSubmitButton = evt.target;
        });
    }

    /** Load start date range  */
    pregnancyleave.loadStartDateRange = function () {
        if ($("[data-expecteddeliverydate]").val()) {
            $.ajax({
                url: "/PregnancyLeave/Home/DetermStartDateRange",
                cache: false,
                data: {
                    expectedDeliveryDate: $("[data-expecteddeliverydate]").val(),
                    multipleBirths: $("[data-multiplebirths]:checked").data("multiplebirths")
                },
                success: function (result) {
                    $("[data-rangestartdate]").html(result.rangestartdate);
                    $("[data-rangeenddate]").html(result.rangeenddate);
                }
            });
        } else {
            $("[data-rangestartdate]").html("-");
            $("[data-rangeenddate]").html("-");
        }
    }

    /** Method that is being called before submitting the request */
    pregnancyleave.submitRequest = function () {
        $("button[type='submit'][name='Action']").prop('disabled', true);
        $(pregnancyleave.clickedSubmitButton).find('span').show();
    }

    /** Shows the spinner button */
    pregnancyleave.showButtonSpinner = function () {
        var spinner = $(pregnancyleave.clickedSubmitButton).find('span');
        spinner.show();
    }

    /** Hides the button spinner */
    pregnancyleave.hideButtonSpinner = function () {
        var spinner = $(pregnancyleave.clickedSubmitButton).find('span');
        spinner.hide();
    }

    /** Refresh method */
    pregnancyleave.refresh = function () {
        pregnancyleave.hideButtonSpinner();

        if (pregnancyleave.calculateButtonClicked) 
            $("[data-submit-button]").prop('disabled', false);
        
        pregnancyleave.loadStartDateRange();
        $('[data-bs-toggle="popover"]').popover();

        let pregnancyLeaveRequestKey = $("[data-pregnancyleave-request-key]").val();
        if (pregnancyLeaveRequestKey)
            pregnancyleave.initAbsencesTable(pregnancyLeaveRequestKey);
    }

    pregnancyleave.initAbsencesTable = function (pregnancyLeaveRequestKey) {
        let table = $('#absencestable').DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: '/PregnancyLeave/Home/SearchAbsences',
                data: {
                    pregnancyLeaveRequestKey: pregnancyLeaveRequestKey
                }
            },
            searchable: false,
            info: false,
            paging: true,
            columns: [
                { data: 'startDate', name: 'StartDate', title: 'Van', sortable: false, searchable: false },
                { data: 'endDate', name: 'EndDate', title: 'T/m', sortable: false, searchable: false },
                { data: 'description', name: 'Description', title: 'Omschrijving', sortable: false, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '15%',
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(data, 'DD-MM-YYYY')
                    }
                },
                {
                    targets: [2],
                    width: '60%'
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a data-bs-toggle='modal' data-bs-target='#modalcontainer' class='btn btn-datatable btn-outline-primary fas fa-trash-alt' title='Verwijderen' href='/PregnancyLeave/Home/DeleteAbsence?key=${full.key}&amp;pregnancyLeaveRequestKey=${pregnancyLeaveRequestKey}'></a>`;
                    }
                }
            ]
        }));
        var columnHeader = table.column(-1).header();
        $(columnHeader).html(`<a data-bs-toggle='modal' data-bs-target='#modalcontainer' class='btn btn-datatable btn-outline-primary fas fa-plus' title='Toevoegen' href='/PregnancyLeave/Home/CreateAbsence?pregnancyLeaveRequestKey=${pregnancyLeaveRequestKey}'></a>`);
    }

}(window.pregnancyleave = window.pregnancyleave || {}, jQuery));

